import { Customer } from '@/types'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { toast } from 'react-hot-toast'

export function useCustomers({ organizationSlug, query }: { organizationSlug: string; query: string }) {
  return useQuery({
    queryKey: ['customers', organizationSlug, query],
    queryFn: () =>
      axios
        .get<Customer[]>('/internal_api/customers', { params: { organization_slug: organizationSlug, query } })
        .then((response) => response.data),
  })
}

export type CustomerFormValues = Pick<Customer, 'first_name' | 'last_name' | 'phone_number' | 'email' | 'address'>

export function useCreateCustomer({ organizationSlug }: { organizationSlug: string }) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (customer: CustomerFormValues) =>
      axios
        .post<Customer>('/internal_api/customers', { customer }, { params: { organization_slug: organizationSlug } })
        .then((response) => response.data),
    onSuccess: () => {
      toast.success('Client créé')
      queryClient.invalidateQueries({ queryKey: ['customers', organizationSlug] })
    },
  })
}
